import React from 'react';
import { EditableComponent } from '@adobe/aem-react-editable-components';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { OBreadcrumb as OBreadcrumbComp } from '@marriott/mi-web-ui-kit';
import clsx from 'clsx';

const TEST_ID = 'designsystem-components-OBreadcrumb';

export const OBreadcrumbConfig = {
  emptyLabel: 'OBreadcrumb',
  isEmpty: () => true,
  resourceType: `${process.env['NEXT_PUBLIC_AEM_SITE']}/components/content/o-breadcrumb`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const OBreadcrumb = (props: any) => {
  const model = props.model || {};
  const { styleclass, componentId } = model;

  return (
    <div data-testid={TEST_ID} data-component-name={`o-${TEST_ID}`} id={componentId} className={clsx(styleclass)}>
      <EditableComponent config={OBreadcrumbConfig} {...props}>
        <OBreadcrumbComp {...props} />
      </EditableComponent>
    </div>
  );
};

export { TEST_ID as O_BREADCRUMB_TEST_ID };
